import { cva, type VariantProps } from 'class-variance-authority'
import { type ReactNode } from 'react'
import { cn } from '#app/utils/misc'

const brandBadge = cva(
	'inline-flex items-center gap-1 rounded-full text-xs font-semibold',
	{
		variants: {
			tone: {
				new: 'bg-gained/[0.13] text-gained-ink',
				lost: 'bg-lost/[0.12] text-lost',
				stable: 'bg-[#F0EDE6] text-[#6B6B72]',
				pick: 'bg-brand font-mono text-[11px] text-white',
			},
			size: {
				default: 'px-[11px] py-1',
				sm: 'px-2.5 py-0.5',
			},
		},
		defaultVariants: { tone: 'new', size: 'default' },
	},
)

export function BrandBadge({
	className,
	tone,
	size,
	children,
}: VariantProps<typeof brandBadge> & {
	className?: string
	children: ReactNode
}) {
	return (
		<span className={cn(brandBadge({ tone, size, className }))}>
			{children}
		</span>
	)
}
